let sessionTimeout;

export const setupSessionTimeout = (logout) => {
    // Clear any existing timeout
    if (sessionTimeout) {
        clearTimeout(sessionTimeout);
    }

    // Set new timeout (e.g., 30 minutes)
    sessionTimeout = setTimeout(() => {
        logout();
    }, 30 * 60 * 1000); // 30 minutes
};

export const refreshSession = (logout) => {
    setupSessionTimeout(logout);
};

export const clearSessionTimeout = () => {
    if (sessionTimeout) {
        clearTimeout(sessionTimeout);
    }
}; 